export const RETURN_VALUE_ERROR_CODES = {
	TRANSACTION_RAN_OUT_OF_GAS: 'TRANSACTION_RAN_OUT_OF_GAS',
	TRANSACTION_UNDERPRICED: 'TRANSACTION_UNDERPRICED',
	REJECTED_TRANSACTION: 'REJECTED_TRANSACTION',
	CALL_REVERTED: 'CALL_REVERTED',
	EXECUTION_REVERTED: 'EXECUTION_REVERTED',
	NONCE_TOO_LOW: 'NONCE_TOO_LOW',
	INSUFFICIENT_FUNDS_FOR_GAS: 'INSUFFICIENT_FUNDS_FOR_GAS',
	MAX_PRIORITY_FEE_PER_GAS_HIGHER_THAN_MAX_FEE_PER_GAS:
		'MAX_PRIORITY_FEE_PER_GAS_HIGHER_THAN_MAX_FEE_PER_GAS',
	MAX_FEE_PER_GAS_LESS_THAN_BLOCK_BASE_FEE: 'MAX_FEE_PER_GAS_LESS_THAN_BLOCK_BASE_FEE',
	UNKNOWN_ERROR: 'UNKNOWN_ERROR',
	USER_REJCTED_TRANSACTION: 'USER_REJCTED_TRANSACTION',
	GAS_LIMIT_ESTIMATION_ERROR: 'GAS_LIMIT_ESTIMATION_ERROR',
	FAILED_TO_PARSE_ERROR: 'FAILED_TO_PARSE_ERROR'
} as const;

export const ETHERS_ERROR_CODES = {
	NONCE_EXPIRED: 'NONCE_EXPIRED',
	UNPREDICTABLE_GAS_LIMIT: 'UNPREDICTABLE_GAS_LIMIT',
	ACTION_REJECTED: 'ACTION_REJECTED',
	CALL_EXCEPTION: 'CALL_EXCEPTION'
};

export const NESTED_ETHERS_ERROR_CODES = {
	REJECTED_TRANSACTION: 4001,
	REQUIRE_TRANSACTION: -32603,
	ERROR_WHILE_FORMATTING_OUTPUT_FROM_RPC: -32603,
	TRANSACTION_UNDERPRICED: -32000
};

export const TRADE_ERROR_CODES = {
	PENDING_ORDER_EXISTS: 'PENDING_ORDER_EXISTS',
	INVALID_LIMIT_PRICE: 'INVALID_LIMIT_PRICE'
};
